import { render, staticRenderFns } from "./FiltersSelected.vue?vue&type=template&id=6e5ac6a2&"
import script from "./FiltersSelected.vue?vue&type=script&lang=js&"
export * from "./FiltersSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5ac6a2')) {
      api.createRecord('6e5ac6a2', component.options)
    } else {
      api.reload('6e5ac6a2', component.options)
    }
    module.hot.accept("./FiltersSelected.vue?vue&type=template&id=6e5ac6a2&", function () {
      api.rerender('6e5ac6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/FiltersSelected.vue"
export default component.exports